// extracted by mini-css-extract-plugin
export default {"cmsContent":"RefundPolicy_cmsContent__53XI0"};